import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';

export const RefundDocumentUploader = ({
  document,
  error,
  onFileChange,
  onFileRemove,
}) => {
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileChange(file);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        alignItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={[
            {
              display: 'flex',
              alignItems: 'center',
              color: error ? 'error.main' : 'text.primary',
            },
          ]}
        >
          RIB {error && <span style={{ color: 'error.main' }}>*</span>}
        </Typography>
      </Box>
      {document ? (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '4px 8px',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '4px',
              backgroundColor: 'background.paper',
            }}
          >
            <Typography
              variant="body2"
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <InsertDriveFileOutlinedIcon fontSize="small" />
              {document.name}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={onFileRemove}
          >
            Supprimer
          </Button>
        </Box>
      ) : (
        <Button variant="contained" component="label" size="small">
          Téléverser le RIB
          <input
            type="file"
            accept=".pdf,.jpg,.png,.jpeg"
            hidden
            onChange={handleFileSelect}
          />
        </Button>
      )}
      {error && (
        <Typography variant="caption" sx={{ color: 'error.main', mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
